import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import {css} from 'styled-components';
import ComponentStyles from 'styles/mixins/Component.styles';
import Drawer from 'components/atoms/Drawers/Drawer/Drawer';
import utils from 'helpers/utils';

const StyledContextDrawer = styled(Drawer)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--context-drawer-bounds-top': props.$wrapper?.boundsCum?.top ?? '0px',
      '--context-drawer-bounds-right': props.$wrapper?.boundsCum?.right ?? '0px',
      '--context-drawer-bounds-bottom': props.$wrapper?.boundsCum?.bottom ?? '0px',
      '--context-drawer-bounds-left': props.$wrapper?.boundsCum?.left ?? '0px',
      '--context-drawer-width': props.$width
    };

    return utils.styleProps(attr, vars);
  })`
  pointer-events: none;
  z-index: ${props => props.theme.property('zIndex.context')};
  
  .ContextDrawer {
    &-content {
      flex-grow: 1;
      height: 1px;
      min-height: fit-content;
      overflow: hidden;
      width: 100%;
      min-width: 1px;
      
      .ContextWrapper {
        &-content {
          overflow: hidden;
        }
      }
    }
  }

  > .MuiPaper-root {
    top: 0;
    position: absolute;
    height: 100%;
    z-index: ${props => props.theme.property('zIndex.context')};
    pointer-events: all;
  }
  
  &.ContextDrawer-persistent {
    position: sticky;
    top: ${props => props.$css.$var('--context-drawer-bounds-top')};
    > .MuiPaper-root {
      position: sticky;
      top: ${props => props.$css.$var('--context-drawer-bounds-top')};

      ${props => !props.$dialog ? css`
        height: calc(100vh - ${props.$css.$var('--context-drawer-bounds-top')} - ${props.$css.$var('--context-drawer-bounds-bottom')});
      ` : css``}
    }
  }

  &.ContextDrawer-temporary {
    z-index: ${props => props.theme.property('zIndex.drawer')};
    > .MuiPaper-root {
      z-index: ${props => props.theme.property('zIndex.drawer')};
    }
    
    &.ContextDrawer-open {
      pointer-events: all;
    }
    
    &.ContextDrawer-showing {
      > .MuiPaper-root {
        transition: ${props => props.theme.transitions.create(['transform'], {
          easing: props.theme.property('transitions.easing.easeInOut'),
          duration: props.theme.property('transitions.duration.enteringScreen')
        })}, ${props => props.theme.transitions.create(['width'], {
          easing: props.theme.property('transitions.easing.easeIn'),
          duration: props.theme.property('transitions.duration.enteringScreen')
        })} !important;
      }
    }
  }

  &.ContextDrawer-anchor {
    &-left {
      left: ${props => props.$css.$var('--context-drawer-bounds-left')};
      > .MuiPaper-root {
        left: ${props => props.$css.$var('--context-drawer-bounds-left')};
      }
    }

    &-right {
      right: ${props => props.$css.$var('--context-drawer-bounds-right')};
      > .MuiPaper-root {
        right: ${props => props.$css.$var('--context-drawer-bounds-right')};
      }
    }
  }
  
  &.ContextDrawer > .MuiPaper-root {
    ${props => utils.isDefined(props.$width) ? css`
      width: ${props.$css.$var('--context-drawer-width', false)};
    ` : css``}
  }

  &.ContextDrawer-persistent {
    &:not(.ContextDrawer-open) > .MuiPaper-root {
      width: 0;
      border-width: 0;
    }
  }
  
  ${ComponentStyles}
`;

StyledContextDrawer.propTypes = {
  theme: PropTypes.object
};

export default StyledContextDrawer;
